<template>
  <div v-if="show" class="container">
    <div class="weight-submission-banner">
      <div class="banner-content">
        <div class="banner-text">
          <span class="banner-title">{{ title }}</span>
          <div class="countdown-inline">
            <span class="countdown-label">Time remaining:</span>
            <div class="countdown-badges">
              <span class="countdown-badge days"
                >{{ formattedTime.days }}d</span
              >
              <span class="countdown-badge hours"
                >{{ formattedTime.hours }}h</span
              >
              <span class="countdown-badge minutes"
                >{{ formattedTime.minutes }}m</span
              >
              <span class="countdown-badge seconds"
                >{{ formattedTime.seconds }}s</span
              >
            </div>
          </div>
        </div>
        <div class="banner-actions">
          <button
            class="submit-btn"
            @click="handleSubmit"
            :disabled="isExpired || !hasStarted"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeightSubmissionAlert",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Pre-Weight Submission: Sunday Race (pending)",
    },
    endTime: {
      type: [String, Number, Date],
      required: true,
    },
    buttonText: {
      type: String,
      default: "Submit",
    },
    startTime: {
      type: [String, Number, Date],
      required: true,
    },
  },
  data() {
    return {
      currentTime: new Date(),
      timer: null,
    };
  },
  computed: {
    timeRemaining() {
      const start = new Date(this.startTime);
      const end = new Date(this.endTime);
      const now = this.currentTime;

      // Check if submission period hasn't started yet
      if (now < start) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          expired: false,
          notStarted: true,
        };
      }

      // Check if submission period has ended
      const diff = end.getTime() - now.getTime();
      if (diff <= 0) {
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          expired: true,
          notStarted: false,
        };
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      return {
        days,
        hours,
        minutes,
        seconds,
        expired: false,
        notStarted: false,
      };
    },
    formattedTime() {
      const { days, hours, minutes, seconds } = this.timeRemaining;
      return {
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
      };
    },
    hasStarted() {
      return !this.timeRemaining.notStarted;
    },

    isExpired() {
      return this.timeRemaining.expired;
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          this.startTimer();
        } else {
          this.clearTimer();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.show) {
      this.startTimer();
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    startTimer() {
      // Clear any existing timer first
      this.clearTimer();

      // Update immediately
      this.currentTime = new Date();

      // Set up interval to update every second
      this.timer = setInterval(() => {
        this.currentTime = new Date();

        if (this.isExpired) {
          this.clearTimer();
          this.$emit("expired");
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleSubmit() {
      // IMPORTANT: Only emit 'submit', don't try to navigate
      // The parent component will handle showing the modal
      this.$emit("submit");
    },
  },
};
</script>
